import { useEffect } from "react";

/*
 * Lightweight SEO helper, updates <title>, meta description, OG/Twitter
 * cards, canonical link, and (optionally) an Article JSON-LD block per
 * route without pulling in react-helmet.
 */
const upsertMeta = (selector, attrKey, attrVal, contentKey, contentVal) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrKey, attrVal);
    document.head.appendChild(el);
  }
  el.setAttribute(contentKey, contentVal);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSEO = ({ title, description, image, url, jsonLd }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', "property", "og:title", "content", title);
      upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", "content", title);
    }
    if (description) {
      upsertMeta('meta[name="description"]', "name", "description", "content", description);
      upsertMeta('meta[property="og:description"]', "property", "og:description", "content", description);
      upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", "content", description);
    }
    if (image) {
      upsertMeta('meta[property="og:image"]', "property", "og:image", "content", image);
      upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", "content", image);
    }
    if (url) {
      upsertMeta('meta[property="og:url"]', "property", "og:url", "content", url);
      upsertLink("canonical", url);
    }

    // Article JSON-LD (or any structured data payload)
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.setAttribute("type", "application/ld+json");
      script.setAttribute("data-route-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, image, url, jsonLd]);
};
